<template>
	<!-- VApp is an element which is required to use Vuetify. @see https://vuetifyjs.com/en/ for help -->
	<VApp v-cloak>
		<AppHeader />

		<NotificationBar data-cy="notificationBar" />
		<VMain
			v-if="state !== StateEnum.PENDING && state !== StateEnum.REJECTED"
			style="background-color: white"
		>
			<!-- Transition between routes -->
			<transition
				name="fade"
				mode="out-in"
			>
				<!-- Load the component defined in the router for the current route -->
				<RouterView />
			</transition>
		</VMain>
		<VMain v-else>
			<transition
				name="fade"
				mode="out-in"
			>
				<div
					v-if="state === StateEnum.PENDING"
					class="h-100 d-flex justify-center align-center"
				>
					<VProgressCircular
						indeterminate
						color="primary"
						size="50"
					/>
				</div>

				<Maintenance
					v-else
					no-btn
				/>
			</transition>
		</VMain>
		<AppFooter v-if="!$maintenanceEnabled" />
	</VApp>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { Meta, MetaInfo } from '@/decorators';
	import { StateEnum } from '@cnamts/vue-dot/src/constants/enums/StateEnum';

	// Static import for faster rendering
	import { AppHeader, AppFooter } from '@/components/layout';
	import getApiStatus from '@/services/ei/status/api';
	import Maintenance from '@/views/Maintenance.vue';

	/** App is the main component */
	@Component({
		components: {
			AppHeader,
			AppFooter,
			Maintenance
		}
	})
	export default class App extends Vue {
		StateEnum = StateEnum;
		state = StateEnum.PENDING;

		async created() {
			try {
				await getApiStatus();
				this.state = StateEnum.RESOLVED;
			} catch {
				this.state = StateEnum.REJECTED;
			}
		}

		/** The meta information of the route */
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				// If a sub-components does not specifies metaInfo.title, this title will be used
				title: this.$t('common.meta.title') as string,
				// All titles will be injected into this template
				titleTemplate: this.$t('common.meta.titleTemplate') as string,
				meta: [
					{
						name: 'description',
						vmid: 'description', /** Used to avoid duplicated tags @see https://vue-meta.nuxtjs.org/faq/#unique-metadata */
						content: this.$t('common.meta.description') as string
					}
				]
			};
		}
	}
</script>

<style lang="scss">
	$color-pack: false;
	@import '~vuetify/src/styles/main.sass';
</style>
